import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss"
import Button from '../../../../component/Button'
import CheckboxComponent from '../../../../component/CheckboxComponent'
import { Collapse, List, ListItem } from '@mui/material';
import { Icons, Images } from '../../../../assets'
import ScrollableTable from '../../../../component/ScrollableTable';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { useDispatch } from 'react-redux';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import config from '../../../../service/env';

const QrBulkQuantities = (props) => {
    const { detailInfo, setQRSetupModal } = props
    const userHeader = [
        { label: 'QR ID', sortable: 'qrCodeId' },
        { label: 'QR img' },
        // { label: 'Action' }
    ];

    const [openItem, setOpenItem] = useState(null);
    const [sortedColumns, setSortedColumns] = useState(null);
    const [selectAll, setSelectAll] = useState(false);
    const [quantityList, setQuantityList] = useState([])
    const [bulkDetailsInfo, setBulkDetailsInfo] = useState([])
    const dispatch = useDispatch();
    const { apiUrl } = config

    useEffect(() => {
        if (detailInfo?.length > 0) {
            const qrItems = detailInfo.map(item => ({
                ...item,
                isChecked: false
            }));
            setQuantityList(qrItems)
        }
    }, [detailInfo])

    useEffect(() => {
        if (sortedColumns && bulkDetailsInfo?.length) {
            let tableData = Object.assign([], bulkDetailsInfo)
            if (sortedColumns?.direction === 'desc') {
                tableData = tableData?.sort((a, b) => b[sortedColumns?.key]?.localeCompare(a[sortedColumns?.key]));
            } else {
                tableData = tableData?.sort((a, b) => a[sortedColumns?.key]?.localeCompare(b[sortedColumns?.key]));
            }
            setBulkDetailsInfo(tableData)
        }
    }, [sortedColumns])

    const handleClick = async (item) => {
        setOpenItem(prevItem => (prevItem === item?.id ? null : item?.id));
        if (openItem === item?.id) {
            setBulkDetailsInfo([])
        } else {
            let url = `${Exported.Endpoints.getQRBulList}`;
            let paramsObj = {
                id: item?.id
            }
            await request({
                url: url,
                params: { ...paramsObj }
            }).then((res) => {
                if (res?.data?.status) {
                    setBulkDetailsInfo(res?.data?.data)
                }
            }).catch((err) => {
                console.log(err, "err")
                Toast({
                    type: 'error',
                    message: 'Unable to process the request!..'
                })
            })
        }
    };

    const downloadBulkQR = (items) => {
        dispatch(saveLoadingState(true))
        window.open(`${apiUrl}/qrcode/download_bulk_qr?id=${items?.at(0)?.qrParentId}`, "_blank")
        dispatch(saveLoadingState(false))
    }

    // const handleSelectAll = () => {
    //     let checked = !selectAll
    //     setSelectAll(checked)
    //     setQuantityList((prevState) => (
    //         prevState.map((item, idx) => (
    //             { ...item, isChecked: checked }
    //         ))
    //     ))
    // }

    // const handleChange = (e, index) => {
    //     e.stopPropagation();
    //     const checked = e.target.checked
    //     setQuantityList((prevState) => (
    //         prevState.map((item, idx) => (
    //             index === idx ? { ...item, isChecked: checked } : item
    //         ))
    //     ))
    // }

    const ListCollapseItems = (props) => {
        const { item } = props
        return (
            <div>
                <div className={`mb-5`}>
                    <ScrollableTable
                        headerDetails={userHeader}
                        listLength={[item]}
                        autoHeight
                    >
                        <div className={`flex items-center rowTableData py-3 h-[auto]`}>
                            <div className={`text-center w-[50%]`}>{item?.qrCodeId}</div>
                            <div className={`flex item-center justify-center w-[50%]`}>
                                <img src={Icons.qrIcon} className={`h-[25px]`} />
                            </div>
                            {/* <div className={`flex item-center justify-center w-[50%]`}>
                                <img src={Images.actionCircle} className={`h-[22px]`} onClick={() => window.open(item?.qrImagePath, '_blank')} />
                            </div> */}
                        </div>
                    </ScrollableTable>
                </div>
                <div className={`${classes.qrCardWrapper}`}>
                    <div className={classes.cardHeader}>{`Individual QR Quantities(${bulkDetailsInfo?.length})`}</div>

                    <div className={`mt-8 mb-4 scrollTableWrapper`}>
                        <ScrollableTable
                            headerDetails={userHeader}
                            listLength={bulkDetailsInfo || []}
                            tableSort
                            sortedColumns={sortedColumns}
                            setSortedColumns={setSortedColumns}
                        >
                            {bulkDetailsInfo?.map((item, index) => {
                                const { id = '', qrCodeId = '' } = item;
                                return (
                                    <div className={`flex items-center rowTableData `} key={id}>
                                        <div className={`text-center w-[50%]`}>{qrCodeId ? qrCodeId : '-'}</div>
                                        <div className={`flex item-center justify-center w-[50%]`}>
                                            <img src={Icons.qrIcon} className={`h-[25px]`} />
                                        </div>
                                        {/* <div className={`flex item-center justify-center w-[50%]`}>
                                            <img src={Images.actionCircle} className={`h-[22px]`} onClick={() => window.open(item?.qrImagePath, '_blank')} />
                                        </div> */}
                                    </div>
                                );
                            })}
                        </ScrollableTable>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className={`${classes.qrCardWrapper} ${classes.bgTransparent} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center justify-between mb-4'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Box QR Quantities ({quantityList?.length})
                        </div>
                        <div>
                            {/* <Button text={'Select all'} secondary smallBtn className={'mx-3'} onClick={handleSelectAll} /> */}
                            {/* {quantityList?.filter((x) => x?.isChecked)?.length > 0 ? */}
                            <Button text={'Download QR code'} smallBtn onClick={() => downloadBulkQR(detailInfo)} />
                            {/* : null} */}
                        </div>
                    </div>
                    <div className=''>
                        <List>
                            {quantityList.map((item, index) => (
                                <div key={item.id}>
                                    <ListItem className={classes.qrQuantities}>
                                        {/* <div className='flex gap-[20px]'>
                                            <CheckboxComponent className={classes.checkboxContainer} checked={item.isChecked} onChange={(e) => handleChange(e, index)} />
                                        </div> */}
                                        <div className='flex justify-between w-[100%] cursor-pointer' onClick={() => handleClick(item)}>
                                            <div className={`${classes.quantityContent}`}>{item.qrCodeId}</div>
                                            <img className={openItem === item.id ? classes.activeList : ''} src={Icons.dropdown} alt="dropdown icon" />
                                        </div>
                                    </ListItem>
                                    {openItem === item.id ?
                                        <Collapse in={openItem === item.id}>
                                            <div>
                                                <ListCollapseItems item={item} />
                                            </div>
                                        </Collapse> : null
                                    }
                                </div>
                            ))}
                        </List>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QrBulkQuantities